import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

import { StripedDataTableWrapper } from '@/components/shared/components/common.StyledComponents';

export const Container = styled.div``;

export const PageTitle = styled.h1`
    font-size: ${rem(28)};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    margin: 0 0 ${rem(24)} 0;
    padding: 0;
`;

export const TableWrapper = styled(StripedDataTableWrapper)`
    background-color: ${({ theme }) => theme.colors.greyscale.white};
    border-radius: ${rem(8)};
`;

export const ProductList = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(2)};
`;

export const StyledLink = styled.a`
    color: ${({ theme }) => theme.colors.primary.actionDefault};
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }

    &:visited {
        color: ${({ theme }) => theme.colors.primary.actionDefault};
    }
`;
